import React, { useState } from "react";
import ChatList from "../../components/ChatList";
import ChatWindow from "../../components/ChatWindow";
import Topbar from "../../components/Topbar";
import StoriesRow from "../../components/StoriesRow";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import Leftsidebar from "../sidebar/leftsidebar";
import { useSocket } from "../../contexts/SocketContext";

const ChatsPage = () => {
  const [selectedChat, setSelectedChat] = useState(null);
  const { socket, joinRoom } = useSocket();

  const chats = [
    {
      id: 15,
      name: "Kaven",
      lastMessage: "How are you today?",
      time: "2 min ago",
      avatar: "https://via.placeholder.com/50",
    },
    {
      id: 22,
      name: "Sushem",
      lastMessage: "Let's meet tomorrow",
      time: "5 min ago",
      avatar: "https://via.placeholder.com/50",
    },
  ];

  const userID = sessionStorage.getItem("userID");

  const handleSelectChat = (chat) => {
    setSelectedChat(chat);
    // Join the chat room when a chat is selected
    if (chat?.id) {
      joinRoom(chat.id);
    }
  };

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />
      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex">
          <div className="flex flex-1">
            <ChatList
              userID={userID}
              chats={chats}
              onSelectChat={handleSelectChat}
            />
            {selectedChat ? (
              <ChatWindow userID={userID} chat={selectedChat} />
            ) : (
              <div className="flex flex-1 items-center justify-center text-gray-400">
                Select a chat to start messaging
              </div>
            )}
          </div>
        </main>
      </main>
    </div>
  );
};

export default ChatsPage;
